import styled from 'styled-components/macro';

export const ClickableImg = styled.img`
  cursor: pointer;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin: auto;
  height:15px;
`;